import { render, staticRenderFns } from "./version-list-item.vue?vue&type=template&id=783b6476&scoped=true&"
import script from "./version-list-item.vue?vue&type=script&lang=ts&"
export * from "./version-list-item.vue?vue&type=script&lang=ts&"
import style0 from "./version-list-item.vue?vue&type=style&index=0&id=783b6476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783b6476",
  null
  
)

export default component.exports